
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminProtectedRoute = () => {
  const location = useLocation();

  const isAuth =
    sessionStorage.getItem("admin_auth") === "true" &&
    Boolean(sessionStorage.getItem("admin_token"));

  if (!isAuth) {
    // Avoid redirecting to the same login route repeatedly.
    if (location.pathname === "/admin/login") {
      return <Outlet />;
    }

    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
